import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import IconError from "@/components/icons/icon-error";

export interface WallValidationError {
	id: string;
	field: string;
	message: string;
	category: "content" | "layout" | "seo";
	group?: string;
}

interface ValidationErrorsTooltipProps {
	errors: WallValidationError[];
	onErrorClick?: (error: WallValidationError) => void;
}

export function ValidationErrorsTooltip({ errors, onErrorClick }: ValidationErrorsTooltipProps) {
	if (errors.length === 0) return null;

	return (
		<DropdownMenu.Root>
			<DropdownMenu.Trigger asChild>
				<button
					type="button"
					className="p-1.5 rounded-md hover:bg-red-50 transition-colors flex items-center gap-1.5"
					aria-label={`${errors.length} validation error${errors.length > 1 ? "s" : ""}`}
				>
					<IconError className="w-5 h-5 text-red-500" />
					<span className="text-sm font-medium text-red-600">
						{errors.length} {errors.length === 1 ? "error" : "errors"}
					</span>
				</button>
			</DropdownMenu.Trigger>

			<DropdownMenu.Portal>
				<DropdownMenu.Content className="bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[280px] max-w-sm z-50" sideOffset={8} align="end">
					<div className="px-3 py-2 border-b border-gray-100">
						<p className="text-sm font-semibold text-gray-900">Please fix the following errors:</p>
					</div>
					<div className="py-1 max-h-64 overflow-y-auto">
						{errors.map((error) => (
							<DropdownMenu.Item
								key={error.id}
								className="px-3 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700 cursor-pointer outline-none flex items-start gap-2 transition-colors"
								onSelect={() => onErrorClick?.(error)}
							>
								<span className="text-red-500 mt-0.5 shrink-0">
									<svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
										<circle cx="12" cy="12" r="10" />
										<line x1="12" y1="8" x2="12" y2="12" />
										<line x1="12" y1="16" x2="12.01" y2="16" />
									</svg>
								</span>
								<p className="flex-1 text-gray-700">{error.message}</p>
							</DropdownMenu.Item>
						))}
					</div>
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
}
